export enum SpeedUnit {
    Rpm,
    NNsyn
}
